import flow from 'lodash-es/flow';
function getCommonFields(data) {
  return {
    manufacturer: data.manufacturer,
    bodyType: data.bodyType,
    mainTypeDetail: data.mainTypeDetail,
    fuelType: data.fuelType,
    horsePower: data.horsePower,
    doorCount: data.doorCount,
    gearType: data.gearType,
    mileage: data.mileage
  };
}
export function mapToQuery(formValues) {
  return {
    ...getCommonFields(formValues),
    model: formValues.mainType,
    builtYear: formValues.builtDate
  };
}
export function mapFromQuery(query) {
  return flow(removeTrailingSlash, mapQuery)(query);
}
function removeTrailingSlash(queryObject) {
  return !queryObject ? null : Object.keys(queryObject).reduce((acc, key) => {
    const value = acc[key];
    if (typeof value === 'string') {
      return value.endsWith('/') ? {
        ...acc,
        [key]: value.slice(0, -1)
      } : acc;
    }
    return acc;
  }, queryObject || {});
}
function mapQuery(queryObject) {
  return queryObject ? {
    ...getCommonFields(queryObject),
    mainType: queryObject?.model,
    builtDate: queryObject?.builtYear
  } : {};
}